import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';
import { isMobile, isTabletDown, isTablet } from './isMobile';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(MotionPathPlugin);
export function HeroSecondScene() {
    //ScrollTrigger.create({
    //    trigger: '.hero-second-scene',
    //    start: () => 'top top',
    //    end: () => '+=75%',
    //    pinSpacing: false,
    //    pin: '.hero-second-scene__grid',
    //    scrub: 1,
    //});
    if (!isTabletDown()) {
        //ScrollTrigger.create({
        //    trigger: '.hero-second-scene',
        //    start: () => 'top top',
        //    end: () => '+=500%',
        //    pinSpacing: false,
        //    pin: '.hero-second-scene__circle-graphics',
        //    scrub: 1,
        //});

        //ScrollTrigger.create({
        //    trigger: '.hero-second-scene',
        //    start: () => 'top top',
        //    end: () => '+=50%',
        //    pinSpacing: false,
        //    pin: '.hero-second-scene__text-block',
        //    scrub: 1,
        //});

        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: '.hero-second-scene',
                start: () => 'top top',
                end: () => '+=50%',
                scrub: 1,
            }
        });
        tl
            .set('.hero', { zIndex: 5, pointerEvents: 'none' })
            .to('#marker-path', {
                duration: .001,
                motionPath: {
                    path: '#arrow-path',
                    align: '#arrow-path',
                    autoRotate: true,
                    alignOrigin: [.5, .5]
                }
            })
            .to('.hero-second-scene__text-block', 1, { autoAlpha: 0 }, '+=1.2')
            .to('.hero__clip-container', 2, { scale: 0.5, y: () => '+=0.6%', transformOrigin: '25% center' }, '-=.4')
            .to('.hero-second-scene__circle-graphics', 3, {
                rotate: 0
                //onComplete: function () {
                //    gsap.set('.hero-third-scene .slider-wrap:first-child', { autoAlpha: 1 })
                //    gsap.fromTo('.hero-third-scene .slider-wrap:first-child .hero-third-scene__grid-item > a',
                //        {
                //            opacity: 0
                //        },
                //        {
                //            opacity: 1,
                //            duration: 0.3,
                //            stagger: {
                //                each: 0.3,
                //                ease: 'power1.out',
                //            }
                //        }
                //    );
                //},
            }, '-=.6')
            .to('.hero-third-scene__grid', { duration: 1, autoAlpha: 1 })
            .set('.hero-second-scene__circle-graphics', { pointerEvents: 'none' })
            .set('.hero-second-scene__circle-graphics > div', { pointerEvents: 'auto' });


        gsap.to('.hero-second-scene__circle-graphics', 1, {
            autoAlpha: 1,
            scrollTrigger: {
                trigger: '.hero-second-scene',
                start: () => 'top top',
                end: () => '+=50%',
                scrub: 1,
            }
        });
    } else {
        //ScrollTrigger.create({
        //    trigger: '.hero-second-scene',
        //    start: () => 'top top',
        //    end: () => '+=300%',
        //    pinSpacing: false,
        //    pin: '.hero-second-scene__circle-graphics',
        //    scrub: 1,
        //});

        //ScrollTrigger.create({
        //    trigger: '.hero-second-scene',
        //    start: () => 'top top',
        //    end: () => '+=100%',
        //    pinSpacing: false,
        //    pin: '.hero-second-scene__text-block',
        //    scrub: 1,
        //});

        var circleSvg = document.querySelector('.hero-second-scene__circle-graphics svg');
        //var imageBlock = document.querySelector('.hero__img-block');
        var clipContainer = document.querySelector('.hero__clip-container');
        //var textBlock = document.querySelector('.hero-second-scene__text-block');
        var hero = document.querySelector('.hero');

        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: '.hero-second-scene',
                start: () => 'top top',
                end: () => '+=100%',
                scrub: 1,
                onEnter: function () {
                    hero.style.pointerEvents = 'none';
                },
                onEnterBack: function () {
                    hero.style.pointerEvents = 'auto';
                },
            }
        });
        tl
            .set('.hero', { zIndex: 5, pointerEvents: 'none' })
            .to('#marker-path', {
                duration: .001,
                motionPath: {
                    path: '#arrow-path',
                    align: '#arrow-path',
                    autoRotate: true,
                    alignOrigin: [.5, .5]
                }
            })
            .to('.hero-second-scene__text-block', 1, { autoAlpha: 0 }, '+=1.2')
            .to('.hero__clip-container', 1, { scale: () => isTablet() ? '.6' : '-=0.07', y: () => { return circleSvg.getBoundingClientRect().top - 91 + (circleSvg.clientHeight - clipContainer.clientHeight) / 2; } }, '-=0.4')
            .to('.hero-second-scene__circle-graphics', 3, {
                rotate: 0,
                //onComplete: function () {
                //    gsap.set('.hero-third-scene .slider-wrap:first-child', { autoAlpha: 1 })
                //    gsap.fromTo('.hero-third-scene .slider-wrap:first-child .hero-third-scene__grid-item > a',
                //        {
                //            opacity: 0
                //        },
                //        {
                //            opacity: 1,
                //            duration: 0.3,
                //            stagger: {
                //                each: 0.3,
                //                ease: 'power1.out',
                //            }
                //        }
                //    );
                //},
            }, '-=.6')
            .to('.hero-third-scene__grid', { duration: 1, autoAlpha: 1 })
            .set('.hero-second-scene', { zIndex: 4, pointerEvents: 'none' })
            .set('.hero-second-scene__circle-graphics', { pointerEvents: 'auto' })
            .set('.hero-third-scene', { zIndex: 3 });

        gsap.to('.hero-second-scene__circle-graphics', 1, {
            autoAlpha: 1,
            scrollTrigger: {
                trigger: '.hero-second-scene',
                start: () => '80% top',
                end: () => '+=20%',
                scrub: 1,
            }
        });
    }
}